import React from 'react';
import { hot } from 'react-hot-loader/root';
import useAuth from 'src/hooks/useAuth';
import { OrgAppRolesProvider } from 'src/hooks/useOrgAppRoles';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import GoBackButton from '../GoBackButton/GoBackButton';
import Loader from '../Loader/Loader';
import OrgUserDetails from './OrgUserDetails';

const OrgUserDetailsLoader: React.FC = () => {
  const { userDetails, isLoading, error } = useOrgUserDetails();
  const { user } = useAuth();

  if (isLoading) {
    return <Loader height={300} />;
  }

  if (error) {
    return (
      <>
        <GoBackButton />
        <ErrorMessage />;
      </>
    );
  }

  if (userDetails) {
    return (
      <>
        <GoBackButton />
        <OrgAppRolesProvider>
          <OrgUserDetails disableActions={user.id === userDetails.UID} />
        </OrgAppRolesProvider>
      </>
    );
  }

  return null;
};

export default hot(OrgUserDetailsLoader);
